import React from "react";

import Stores from "./stores/Stores";
import Comparators from "./comparators/Comparators";
import CustomSelection from "./customSelection/CustomSelection";

import { useAppSelector } from "store";
import { FilterStep, selectActiveStep } from "modules/customer/insights/portfolio/filters/filtersSlice";

const Content: React.FC = () => {
    const activeStep = useAppSelector(selectActiveStep);

    return (
        <>
            {activeStep === FilterStep.SelectStore && (<Stores />)}
            {activeStep === FilterStep.SelectComparator && (<Comparators />)}
            {activeStep === FilterStep.CustomSelection && (<CustomSelection />)}
        </>
    );
};

export default Content;
